import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import MemberList from './components/Members/MemberList';
import MemberForm from './components/Members/MemberForm';
import MemberDetails from './components/Members/MemberDetails';
import MemberRegistration from './components/Members/MemberRegistration';
import LoanList from './components/Loans/LoanList';
import LoanApplication from './components/Loans/LoanApplication';
import LoanDetails from './components/Loans/LoanDetails';
import SavingsAccountList from './components/Savings/SavingsAccountList';
import SavingsTransaction from './components/Savings/SavingsTransaction';
import SavingsForm from './components/Savings/SavingsForm';
import DailyCollection from './components/Collections/DailyCollection';
import CollectionHistory from './components/Collections/CollectionHistory';
import ReportGenerator from './components/Reports/ReportGenerator';
import Login from './components/Auth/Login';
import { useAuth } from './context/AuthContext';
import MemberApproval from './components/Members/MemberApproval';
import LoanProducts from './components/Loans/LoanProducts';
import Attendance from './components/Employees/Attendance';
import RealTimeDashboard from './components/Dashboard/RealTimeDashboard';
import LoanApproval from './components/Loans/LoanApproval';
import Settings from './components/Settings/Settings';
import CollectionReport from './components/Reports/CollectionReport';

import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }>
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />

        {/* Member Routes */}
        <Route path="members" element={<MemberList />} />
        <Route path="members/new" element={<MemberRegistration />} />
        <Route path="members/pending" element={<MemberApproval />} />
        <Route path="members/:id" element={<MemberDetails />} />
        <Route path="members/:id/edit" element={<MemberForm />} />

        {/* Loan Routes */}
        <Route path="loans" element={<LoanList />} />
        <Route path="loans/apply" element={<LoanApplication />} />
        <Route path="loans/pending" element={<LoanApproval />} />
        <Route path="loans/:id" element={<LoanDetails />} />

        {/* Savings Routes */}
        <Route path="savings" element={<SavingsAccountList />} />
        <Route path="savings/new" element={<SavingsForm />} />
        <Route path="savings/:accountId/transactions" element={<SavingsTransaction />} />

        {/* Collection Routes */}
        <Route path="collections/daily" element={<DailyCollection />} />
        <Route path="collections/history" element={<CollectionHistory />} />
        <Route path="reports/collection" element={<CollectionReport />} />

        <Route path="loans/products" element={<LoanProducts />} />
        <Route path="employees/attendance" element={<Attendance />} />
        <Route path="dashboard/realtime" element={<RealTimeDashboard />} />

        {/* Report Routes */}
        <Route path="reports" element={<ReportGenerator />} />

        {/* Settings Routes */}
        <Route path="settings" element={<Settings />} />

      </Route>
    </Routes>
  );
}

function App() {
  return (
      <AuthProvider>
        <Toaster position="top-right" />
        <AppRoutes />
      </AuthProvider>
  );
}

export default App;